<template>
	<app-section>
		<app-title title="Map" />
		<app-line />
		<div class="relative" style="height: 300px">
			<app-map-image
				:coordinates="coordinates"
				:editable="false"
				@updateAddress="$emit('updateAddress', $event)"
			/>
		</div>
	</app-section>
</template>

<script>
	import AppMapImage from '@/components/app/AppMapImage';

	export default {
		name: 'MapDetails',
		components: { AppMapImage },
		emits: ['updateAddress'],
		props: {
			coordinates: {
				required: true,
				type: Object,
			},
		},
	};
</script>
